import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { reduxForm } from "redux-form";

import { setIdempotencyKey, submit } from "../../../Actions/confirmationActions";
import { IStore, Step, IServiceStepInfo } from "../../../DataTypes/storeTypes";
import { IConfirmData } from "../../../DataTypes/confirmationTypes";
import { ClientPortalPaymentModes } from "../../../../Common/organisationInfo";

import { PaymentFormConnected } from "./PaymentForm";
import { SummaryConnected } from "./Summary";
import { TermsAndSubmitConnected } from "./TermsAndSubmit";
import { selectIsStripeConnected, selectPortalPaymentMode } from "../../../Helpers/selectors";
import { Stripe, StripeElements } from "@stripe/stripe-js";

interface IProps {
    amount: number;
    handleSubmit();
    onSubmit(values);

    stripe: Stripe;
    elements: StripeElements;
    paymentsEnabled: boolean;
}

class Confirmation extends Component<IProps> {
    render() {
        const { amount, paymentsEnabled } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-lg-11 ml-lg-auto mr-lg-auto">
                    <form onSubmit={this.props.handleSubmit}>
                        <div
                            className={`confirmation-box mb-4 ${amount === 0 || !paymentsEnabled ? "one-column" : ""}`}
                        >
                            <div className="row">
                                {amount > 0 ? (
                                    <>
                                        <div className={`col-12 col-md-${paymentsEnabled ? "6" : "8"} mb-3 mb-md-0`}>
                                            <SummaryConnected />
                                        </div>

                                        <div className={`col-12 col-md-${paymentsEnabled ? "6" : "4"}`}>
                                            <PaymentFormConnected />
                                        </div>
                                    </>
                                ) : (
                                    <div className="col-12">
                                        <SummaryConnected />
                                    </div>
                                )}
                            </div>

                            <TermsAndSubmitConnected />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const ConfirmationReduxForm = reduxForm({
    form: "submitForm",
    getFormState: (state: IStore) => state.submitForm,
    initialValues: {
        storecard: true,
        conditions: true,
    },
})(Confirmation);

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    const serviceInfo = state.stepsInfo[Step.Service] as IServiceStepInfo;
    const paymentMode = selectPortalPaymentMode(state);

    return {
        ...ownProps,
        amount: serviceInfo.amount ? serviceInfo.amount : 0,
        paymentsEnabled:
            (paymentMode !== ClientPortalPaymentModes.Disabled || serviceInfo.hasPortalDeposit) &&
            selectIsStripeConnected(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        onSubmit: (values: IConfirmData) => {
            dispatch(setIdempotencyKey());
            dispatch(submit(values, ownProps.stripe, ownProps.elements));
        },
    };
};

export const ConfirmationFormInjected: ConnectedComponent<typeof ConfirmationReduxForm, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmationReduxForm);
